import React, { Fragment } from 'react'
import { Navigate } from 'react-router-dom'
import { withRouter } from 'router'
// import { withRouter } from 'router'
import { connect } from 'react-redux'
import NProgress from 'nprogress'
import { Helmet } from 'react-helmet'
// import Loader from 'components/cleanui/layout/Loader'
// import AuthLayout from './Auth'
import EmptyLayout from './Empty'
import MobileLayout from './Mobile'

const Layouts = {
  // auth: AuthLayout,
  empty: EmptyLayout,
  mobile: MobileLayout,
}

// const Main2List = ['/main', '/email']

const mapStateToProps = ({ user }) => ({
  authorized: user.authorized,
  loading: user.loading,
})

// const Layout = ({ user, children, location }) => {
@connect(mapStateToProps)
class Layout extends React.Component {
  state = {
    layoutElem: null,
  }

  componentDidMount() {
    const layoutElem = this.getLayoutElem()
    this.setState({ layoutElem })
  }

  componentDidUpdate(prevProps) {
    const { location, loading, authorized } = this.props
    const { pathname } = location

    // console.log(' ----- componentDidUpdate ----- ', prevProps)
    if (
      pathname !== prevProps.location.pathname ||
      authorized !== prevProps.authorized ||
      loading !== prevProps.loading
    ) {
      window.scrollTo(0, 0)
      NProgress.start()

      const layoutElem = this.getLayoutElem()
      this.setState({ layoutElem })

      setTimeout(() => {
        NProgress.done()
      }, 300)
    }
  }

  componentWillUnmount() {}

  // Layout Rendering
  getLayout = () => {
    const { location } = this.props
    const { pathname } = location

    if (pathname.indexOf('/empty') === 0) {
      return 'empty'
    }
    // if (pathname.indexOf('/conversation') === 0) {
    //   return 'main2'
    // }
    // if (Main2List.indexOf(pathname) >= 0) {
    //   return 'main2'
    // }
    return 'mobile'
  }

  getLayoutElem = () => {
    const { authorized, loading, children } = this.props
    const layout = this.getLayout()
    const Container = Layouts[layout]

    // const isAuthLayout = layout === 'auth'
    // if (loading && !authorized && !isAuthLayout) {
    //   return null
    // }

    if (authorized && pathname.indexOf('/auth/login') === 0) {
      return <Navigate to="/main" />
    }

    // in other case render previously set layout
    return <Container>{children}</Container>
  }

  render() {
    const { layoutElem } = this.state

    return (
      <Fragment>
        {/* <Helmet titleTemplate="OfficeMail | %s" title="OfficeMail" /> */}
        <Helmet titleTemplate="OfficeMail" title="OfficeMail" />
        {layoutElem}
      </Fragment>
    )
  }
}

export default withRouter(connect(mapStateToProps)(Layout))
